import React, { useEffect, useState } from 'react'
import styles from './Tel.module.css'
import { FormTitle } from '../../../Common/FormTitle'
import { NextButton } from '../../../Common/CtaButton/NextButton'
import { FormField } from '../../../Common/FormField'
import { validateForm } from './validate'
import { LeadText } from '../../../Common/LeadText'
import { HandleBlurFunction } from './types'
import { useAbTestGtm } from '../../../../hooks/useAbTestGtm'

export const Tel = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const [tel, setTel] = useState('')
    const [isFormValid, setIsFormValid] = useState(false)
    const [errors, setErrors] = useState({tel: ''})
    const [touched, setTouched] = useState({tel: false})

    useEffect(() => {
        const validateAndSetState = async () => {
            const { errors: validationErrors, isValid } = await validateForm(
                tel,
                touched
            )
            setErrors(validationErrors)
            setIsFormValid(isValid)
        }

        validateAndSetState()
    }, [tel, touched])

    const handleBlur: HandleBlurFunction = field => {
        setTouched(prev => ({
            ...prev,
            [field]: true,
        }))
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText='連絡先は？'
                        dataViewLabel={dataViewLabel('EF_StepForm_電話番号')}
                        dataClickLabel={dataClickLabel('EF_StepForm_電話番号-戻る')}
                    />
                </div>
                <div className={styles.telField}>
                    <FormField
                        label='電話番号'
                        placeholder='09012345678'
                        value={tel}
                        isInputType={'tel'}
                        onChange={setTel}
                        onBlur={() => handleBlur('tel')}
                        maxLength={11}
                    />
                    {errors.tel && (
                        <p className={styles.errorMessages}>{errors.tel}</p>
                    )}
                    <LeadText text='ハイフン「-」の入力は不要です' />
                </div>
                <NextButton
                    formKey={['tel']}
                    formValue={[tel]}
                    displayFormKey={['tel']}
                    displayFormValue={[tel]}
                    isDisabled={!isFormValid}
                    dataClickLabel={dataClickLabel('EF_StepForm_電話番号-次へ')}
                />
            </div>
        </div>
    )
}
